module.exports = __webpack_public_path__ + "static/christos-artist-profile-medium-33bfd40d35e3938007d73ed0efbc1d61.jpg";